import { prop, getSymbolFromCurrency, formatPrice } from '../../../utilities';

export enum cartRoutes {
  INDEX = 'routes:kosik',
}

export const remapDeliveryItem = (
  item: any,
  isB2B?: boolean,
): {
  id: number;
  name: string;
  price: string | JSX.Element;
  desc: string;
} | null => {
  if (!item) {
    return null;
  }
  const currency =
    prop(item, 'price.currency_id') || prop(item, 'price.currency', 'EUR');
  let price = isB2B
    ? prop(item, 'price.priceWithoutVat', 0)
    : prop(item, 'price.price', 0);
  if (!price) {
    price = prop(item, 'price.price', 0);
  }
  const priceReadable = formatPrice(price, currency);

  return {
    ...item,
    id: item.delivery_id,
    name:
      prop(item, 'translations.0.delivery_name') || prop(item, 'delivery_name'),
    price: priceReadable,
    desc:
      prop(item, 'translations.0.delivery_descr') ||
      prop(item, 'delivery_descr'),
  };
};

export const remapPaymentItem = (
  item: any,
  isB2B?: boolean,
): { id: number; name: string; price: string | JSX.Element; desc: string } => {
  const currency =
    prop(item, 'price.currency_id') || prop(item, 'price.currency', 'EUR');
  let price = isB2B
    ? prop(item, 'price.priceWithoutVat', 0)
    : prop(item, 'price.price', 0);
  if (!price) {
    price = prop(item, 'price.price', 0);
  }
  const priceReadable = formatPrice(price, currency);
  return {
    id: prop(item, 'payment_id'),
    name:
      prop(item, 'translations.0.payment_name') || prop(item, 'payment_name'),
    price: priceReadable,
    desc:
      prop(item, 'translations.0.payment_descr') || prop(item, 'payment_descr'),
  };
};

export const phonePrefixes = [
  '+421',
  '+420',
  '+43',
  '+32',
  '+359',
  '+385',
  '+357',
  '+45',
  '+372',
  '+358',
  '+33',
  '+49',
  '+30',
  '+36',
  '+354',
  '+353',
  '+39',
  '+371',
  '+423',
  '+370',
  '+352',
  '+356',
  '+31',
  '+47',
  '+48',
  '+351',
  '+40',
  '+386',
  '+34',
  '+46',
];

export const removePhonePrefix = (phonePrefixes, phone) => {
  if (phone && phonePrefixes.length) {
    phonePrefixes.sort((a, b) => b.length - a.length);
    for (const phonePrefix of phonePrefixes) {
      if (phone.startsWith(phonePrefix)) {
        phone = phone.replace(phonePrefix, '');
        return phone.trim();
      }
    }
  }

  return phone;
};

function findPos(obj) {
  let curtop = 0;
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop;
      obj = obj.offsetParent;
    } while (obj);
    return curtop;
  }

  return curtop;
}

export function scrollToElement(className, offsetSize = 0, timeout = 0) {
  if (typeof window.scrollTo !== 'function') {
    return;
  }
  setTimeout(() => {
    const errorElements = document.getElementsByClassName(className);
    if (errorElements.length > 0) {
      const errorElement = errorElements[0];
      const position = findPos(errorElement);
      try {
        window.scrollTo({
          top: position - offsetSize,
          left: 0,
          behavior: 'smooth',
        });
      } catch (e) {
        console.log(e);
      }
    }
  }, timeout);
}

const WINDOWS_1250_CHAR_CODES = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
  105,
  106,
  107,
  108,
  109,
  110,
  111,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  122,
  123,
  124,
  125,
  126,
  127,
  160,
  164,
  166,
  167,
  168,
  169,
  171,
  172,
  173,
  174,
  176,
  177,
  180,
  181,
  182,
  183,
  184,
  187,
  193,
  194,
  196,
  199,
  201,
  203,
  205,
  206,
  211,
  212,
  214,
  215,
  218,
  220,
  221,
  223,
  225,
  226,
  228,
  231,
  233,
  235,
  237,
  238,
  243,
  244,
  246,
  247,
  250,
  252,
  253,
  258,
  259,
  260,
  261,
  262,
  263,
  268,
  269,
  270,
  271,
  272,
  273,
  280,
  281,
  282,
  283,
  313,
  314,
  317,
  318,
  321,
  322,
  323,
  324,
  327,
  328,
  336,
  337,
  340,
  341,
  344,
  345,
  346,
  347,
  350,
  351,
  352,
  353,
  354,
  355,
  356,
  357,
  366,
  367,
  368,
  369,
  377,
  378,
  379,
  380,
  381,
  382,
  711,
  728,
  729,
  731,
  733,
  8211,
  8212,
  8216,
  8217,
  8218,
  8220,
  8221,
  8222,
  8224,
  8225,
  8226,
  8230,
  8240,
  8249,
  8250,
  8364,
  8482,
];

export function validateCartInput(value: string): boolean {
  if (!value) {
    return true;
  }

  for (let i = 0; i < value.length; i++) {
    const charCode = value.charCodeAt(i);
    if (!WINDOWS_1250_CHAR_CODES.includes(charCode)) {
      return false;
    }
  }

  return true;
}

export function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

export function isPositiveNumeric(value) {
  return /^\d+$/.test(value);
}

export function productHasGift(
  giftObject: any,
  domainId?: number,
  isB2B?: boolean,
  hasUser?: boolean,
) {
  return prop(
    giftObject,
    `${isB2B ? 'B2B' : hasUser ? 'REG' : 'B2C'}.${domainId}`,
  );
}

export function removeDiacritics(input:string) {
  if(input){
    return input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  return input;
}
